import React, { createContext, useState, useContext, ReactNode } from 'react';

interface TransactionType {
    label: string;
    value: string;
}

interface DonationFilterContextType {
    year: string;
    month: string;
    donationtype: string;
    donationpurpose: string;
    ezpayStatus: string;
    setyear: (value: string) => void;
    setmonth: (value: string) => void;
    setdonationtype: (value: string) => void;
    setdonationpurpose: (value: string) => void;
    setEzpayStatus: (value: string) => void;
    transactionTypes: TransactionType[];
    setTransactionTypes: (types: TransactionType[]) => void;
}

const DonationFilterContext = createContext<DonationFilterContextType | undefined>(undefined);

const DonationFilterProvider = ({ children }: { children: ReactNode }) => {

    const [year, setyear] = useState<string>("");
    const [month, setmonth] = useState<string>("");
    const [donationtype, setdonationtype] = useState<string>("");
    const [donationpurpose, setdonationpurpose] = useState<string>("");
    const [ezpayStatus, setEzpayStatus] = useState<string>("");


    const [transactionTypes, setTransactionTypes] = useState<TransactionType[]>([]);

    return (
        <DonationFilterContext.Provider
            value={{
                year,
                month,
                donationtype,
                donationpurpose,
                ezpayStatus,
                setyear,
                setmonth,
                setdonationtype,
                setdonationpurpose,
                setEzpayStatus,
                transactionTypes,
                setTransactionTypes,
            }}
        >
            {children}
        </DonationFilterContext.Provider>
    );
};


export const useDonationFilterContext = () => {
    const context = useContext(DonationFilterContext);
    if (!context) {
        throw new Error("useFilterContext must be used within a FilterProvider");
    }
    return context;
};

export default DonationFilterProvider;